var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 6.06218,
    height: 3.375,
    viewBox: "0 0 6.06218 3.375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron",
    d: "M3.03109 0L6.06218 3.375H0L3.03109 0Z",
    fill: "black",
    fillOpacity: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronSmall);
export default __webpack_public_path__ + "static/media/chevron-small.f1abd11ec81da15d6ded9f427026b883.svg";
export { ForwardRef as ReactComponent };